import { Video } from 'lucide-react';

import type { ScriptElement, VideoContent } from '@/lib/schema.types';

export function VideoElement({ element }: { element: ScriptElement }) {
  const c = element.content as VideoContent | undefined;
  if (!c?.src) {
    return (
      <div className="flex aspect-video w-full items-center justify-center rounded-md bg-black/5 text-fg-subtle">
        <Video size={20} />
      </div>
    );
  }
  return (
    <video
      src={c.src}
      poster={c.poster}
      controls
      className="block aspect-video w-full rounded-md"
    />
  );
}
